module.exports = __webpack_public_path__ + "static/media/IMG_5729.ae0d8f6e.jpg";